import { render, staticRenderFns } from "./MoveInIcon.vue?vue&type=template&id=74e6ce89&"
import script from "./MoveInIcon.vue?vue&type=script&lang=js&"
export * from "./MoveInIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports